import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-svg-menu',
  imports: [],
  template: `
    <svg class="stroke-black dark:stroke-white" viewBox="0 0 24 24">
      <path d="M4 18L20 18" stroke-width="2" stroke-linecap="round" />
      <path d="M4 12L20 12" stroke-width="2" stroke-linecap="round" />
      <path d="M4 6L20 6" stroke-width="2" stroke-linecap="round" />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgMenu {}
